import React, { Component } from 'react'
import { Modal, Skeleton, Select, Radio, Typography, Button, message } from 'antd'
import { IntegrationContextData } from '../../../context/IntegrationContext'
import { IntegrationPartnerContextData } from '../../../context/IntegrationPartnerContext'
import { AdoptionApplicationForceSetAdoptedRequest } from '../../../services/api/interfaces/ApiRequest'

type SetForceAdoptedProps = {
  applicationUuid: string,
  shelterUuid: string,
  branchUuid: string,
  status?:string,
  integrationContext: IntegrationContextData,
  integrationPartnerContext: IntegrationPartnerContextData,

  adoptionApplicationForceSetAdopted: (args: AdoptionApplicationForceSetAdoptedRequest) => Promise<any>,

  onClose: (saved?: boolean) => void
}

export default class SetForceAdopted extends Component<SetForceAdoptedProps> {

  state = {
    visible: true,
    loaded: false,
    saving: false,

    showProcessAdoptionStatus: undefined,
    canSelectAdoptionStatus: false,
    selectedAdoptionStatus: null as any
  }
  async componentDidMount() {
    const { shelterUuid, branchUuid, integrationContext, integrationPartnerContext } = this.props
 

    try {
      const shelterIntegrations = await integrationContext.requestVerifyShelter({ shelter_uuid: shelterUuid })

      const integration = shelterIntegrations?.find(v => v.partner_key === 'SHELTER_BUDDY' && v.branch.uuid === branchUuid)
  
      if (integration) {
        await integrationPartnerContext.requestListAdoptionStatus({
          integration_uuid: integration.uuid,
          partner: 'shelterbuddy'
        })
      }
  
      this.setState({
        loaded: true,
        canSelectAdoptionStatus: !!integration
      })
  
      let disableSB = (!!integration && this.props.status === 'PENDING') || (!!integration && this.props.status === 'UNDER_REVIEW');
      if(disableSB){
        this.setState({
          showProcessAdoptionStatus: false
        })
      }
    } catch (error) {
      console.log(error)
      if(error)
      this.handleModalClose()
    }
   
  }

  handleModalClose = (saved?: boolean) => {
    this.setState({
      visible: false
    })

    setTimeout(() => {
      this.props.onClose(saved)
    }, 1000)
  }

  handleShowProcessAdoptionStatus = (ev) => {
    this.setState({
      showProcessAdoptionStatus: ev.target.value
    })
  }

  handleAdoptionStatusSelect = (value: any) => {
    this.setState({
      selectedAdoptionStatus: value
    })
  }

  handleSave = () => {
    const { applicationUuid, integrationContext, adoptionApplicationForceSetAdopted } = this.props
    const { showProcessAdoptionStatus, selectedAdoptionStatus } = this.state

    this.setState({
      saving: true
    }, async () => {
      try {
        if (showProcessAdoptionStatus) {
          await integrationContext.requestNotifyAdoptionInfo({
            application_uuid: applicationUuid,
            status_id: selectedAdoptionStatus.toString()
          })
        }

        await adoptionApplicationForceSetAdopted({
          uuid: applicationUuid
        })

        message.success('Application adoption forced as adopted successfully!')
        this.handleModalClose()
      } catch (err) {
        message.error(`Application adoption forced as adopted failed. Error: ${err}`)
        this.setState({
          saving: false
        })
      }
    })
  }

  renderContent = () => {
    const { integrationPartnerContext } = this.props
    const { loaded, canSelectAdoptionStatus, showProcessAdoptionStatus } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    const adoptionStatusOptions = integrationPartnerContext.adoptionStatus?.map(v => {
      return {
        label: v.name,
        value: v.value
      }
    }) as any

    let disableSB = (canSelectAdoptionStatus && this.props.status === 'PENDING') || (canSelectAdoptionStatus && this.props.status === 'UNDER_REVIEW');

    


    return (
      <>
        {
          canSelectAdoptionStatus && (
            <div style={{textAlign: 'center', marginBottom: 15}}>
              <Typography.Title level={5}>
              Process Pet Outcome in Shelter Buddy?
              </Typography.Title>

              <Radio.Group
                options={[
                  {
                    label: 'Yes',
                    value: true,
                    disabled: disableSB
                  },
                  {
                    label: 'No',
                    value: false,
                  }
                ]}
                onChange={this.handleShowProcessAdoptionStatus}
                defaultValue={disableSB ? false : null}
                optionType="button"
              />
              <br/>
              <br/>
              {disableSB && <Typography.Text style={{marginTop: 16,color: "red"}} >Outcome can only be processed in SB for Approved, Signed & Paid statuses</Typography.Text>}
            </div>
          )
        }

        {
          showProcessAdoptionStatus && (
            <div style={{textAlign: 'center'}}>
              <Typography.Title level={5}>
                Please, select an outcome status:
              </Typography.Title>

              <Select
                placeholder="Select a Adoption Status"
                options={adoptionStatusOptions}
                onChange={this.handleAdoptionStatusSelect}
                style={{minWidth: 200}}
              />
            </div>
          )
        }

        {
          (showProcessAdoptionStatus === false || !canSelectAdoptionStatus) && (
            <Typography.Title level={5} style={{textAlign: 'center'}}>
              Are you sure about setting this application as adopted?
            </Typography.Title>
          )
        }
      </>
    )
  }

  renderFooter = () => {
    const { saving, showProcessAdoptionStatus, selectedAdoptionStatus } = this.state

    const ctaDisabled = showProcessAdoptionStatus && !selectedAdoptionStatus

    return (
      <>
        {
          !showProcessAdoptionStatus ? (
            <Button
              type="default"
              onClick={() => this.handleModalClose()}
            >
              No
            </Button>
          ) : null
        }

        <Button
          type="primary"
          loading={saving}
          disabled={ctaDisabled}
          onClick={this.handleSave}
        >
          { showProcessAdoptionStatus ? 'Save' : 'Yes' }
        </Button>
      </>
    )
  }

  render() {
    const { visible, loaded, canSelectAdoptionStatus, showProcessAdoptionStatus } = this.state

    return (
      <Modal
        title="Force Set Adopted"
        visible={visible}
        footer={loaded && (showProcessAdoptionStatus !== undefined || !canSelectAdoptionStatus) ? this.renderFooter() : null}
        closable={loaded}
        onCancel={() => this.handleModalClose()}
      >
        {
          this.renderContent()
        }
      </Modal>
    )
  }
}
